var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","full-height":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('img',{attrs:{"src":require("../../assets/images/home.png"),"width":"100%"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }